export enum ContentStatus {
  INITIATED = 'initiated',
  ERROR = 'error',
  LOADING = 'loading',
  OK = 'ok',
}
